import shadeColor from '../../../utils/shadeColor';
import { BUTTON_HOVER_BRIGHTNESS } from '../constants';
import { ButtonPropsWithTheme } from '../types';

const buttonColor = (props: ButtonPropsWithTheme): string => {
  let base = props.theme.global.primary;

  if (props.success) {
    base = props.theme.states.success.default;
  } else if (props.danger) {
    base = props.theme.states.danger.default;
  } else if (props.warning) {
    base = props.theme.states.warning.default;
  } else if (props.secondary) {
    base = props.theme.text.secondary;
  } else if (props.white) {
    base = 'white';
  }

  let boxShadow = 'none';
  let focusedBoxShadow = 'none';

  let background = base;
  let hoverBackground;

  const borderColor = base;
  let hoverBorderColor;

  let color = 'white';
  let hoverColor = color;

  if (props.outline) {
    color = base;
    if (base === 'white') {
      hoverColor = color;
    } else {
      hoverColor = shadeColor(color, BUTTON_HOVER_BRIGHTNESS - 1);
    }

    hoverBorderColor = hoverColor;

    background = 'transparent';
    hoverBackground = background;
  } else {
    if (base === 'white') {
      color = 'black';
      hoverColor = color;
      background = 'white';
      hoverBackground = background;
      hoverBorderColor = background;
    } else {
      boxShadow = '0 5px 20px 0 rgba(0,0,0,0.20)';
      hoverBackground = shadeColor(background, BUTTON_HOVER_BRIGHTNESS - 1);
      hoverBorderColor = hoverBackground;
    }

    if (!props.disabled) {
      focusedBoxShadow = '0 2px 10px 0 rgba(0,0,0,0.20)';
    }
  }

  if (props.disabled || props.submitting) {
    hoverColor = color;
    hoverBackground = background;
    hoverBorderColor = borderColor;
  }

  return `
    background: ${background};
    border-color: ${borderColor};
    color: ${color};
    box-shadow: ${boxShadow};

    &:active, &:focus {
      box-shadow: ${focusedBoxShadow};
    }

    &:hover, &:active, &:focus {
      color: ${hoverColor};
      background: ${hoverBackground};
      border-color: ${hoverBorderColor};
    }
  `;
};

export default buttonColor;
